import intl from 'react-intl-universal'
import { getEvidentlyFeatures } from '~/evidentlyFeatureFlags'

function evidentlyService(toastr, $rootScope) {
  let featuresInstance
  let featuresInstancePromise

  this.instance = () => {
    // Resolve with the singleton instance
    if (featuresInstance) {
      return Promise.resolve(featuresInstance)
    }

    // Respond with the promise while request is in flight
    if (featuresInstancePromise) {
      return featuresInstancePromise
    }

    featuresInstancePromise = getEvidentlyFeatures()

    return featuresInstancePromise
      .then((features) => {
        featuresInstancePromise = null
        featuresInstance = features
        // for legacy code synchronous access
        // It should be safe to access to the $rootScope.features because all angular routes has a dependency
        // on setting service and fetch settings method which will call featureFlagService().instance() method
        $rootScope.evidentlyFeatures = features
        return featuresInstance
      })
      .catch((error) => {
        featuresInstancePromise = null
        toastr.error(intl.get('initialLoads.featureFlags.error'))
        throw error
      })
  }
}

export default ['toastr', '$rootScope', evidentlyService]
